export var MuiButtonOverrides = {
  defaultProps: {
    color: 'secondary',
    variant: 'contained'
  },
  styleOverrides: {
    root: {
      borderRadius: 9999,
      textTransform: 'none'
    },
    iconSizeSmall: {
      '& > *:first-of-type': {
        fontSize: 20
      }
    },
    iconSizeMedium: {
      '& > *:first-of-type': {
        fontSize: 20
      }
    },
    iconSizeLarge: {
      '& > *:first-of-type': {
        fontSize: 24
      }
    },
    sizeLarge: {
      fontSize: '15px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '26px' /* 173.333% */,
      letterSpacing: '0.46px',
      height: 48,
      padding: '11px 22px'
    },
    sizeMedium: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '24px' /* 171.429% */,
      letterSpacing: '0.46px',
      height: 40,
      padding: '8px 16px'
    },
    sizeSmall: {
      fontSize: '0.8125rem',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '22px' /* 169.231% */,
      letterSpacing: '0.46px',
      height: 32,
      padding: '5px 10px'
    }
  }
};